import React, { useState } from "react";
import { auth } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { logService } from "../utils/logService";
import Header from "./Header";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const validate = () => {
    if (!email) {
      toast.error("Email is required");
      return false;
    }
    // Simple email regex
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Please enter a valid email address");
      return false;
    }
    if (!password) {
      toast.error("Password is required");
      return false;
    }
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // Log the user login
      await logService.createLog(
        logService.actions.USER_LOGGED_IN,
        {
          email: user.email,
          uid: user.uid,
        },
        {
          uid: user?.uid,
          email: user?.email,
          displayName: user?.displayName,
        }
      );

      toast.success("Signed in successfully!");
      setTimeout(() => navigate("/dashboard"), 1000);
    } catch (err) {
      toast.error(err.message.replace("Firebase:", "").trim());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-valia-background-primary flex flex-col">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          {/* Header */}
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-valia-primary mb-2">
              Welcome Back
            </h1>
            <p className="text-valia-gray-600 text-sm">
              Sign in to your Valia account
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            className="valia-form"
            autoComplete="off"
          >
            <div className="valia-form-group">
              <div>
                <label htmlFor="email" className="valia-label">
                  Email Address
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="valia-input"
                  required
                  autoFocus
                />
              </div>

              <div>
                <label htmlFor="password" className="valia-label">
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="valia-input"
                  required
                />
              </div>
            </div>

            <div className="mt-8">
              <button
                type="submit"
                className={`w-full valia-btn-primary valia-btn-sm ${
                  loading ? "valia-btn-loading" : ""
                }`}
                disabled={loading}
              >
                {loading ? (
                  <div className="flex items-center justify-center">
                    <div className="valia-spinner w-4 h-4 mr-2"></div>
                    Signing In...
                  </div>
                ) : (
                  "Sign In"
                )}
              </button>
            </div>

            <div className="mt-4 text-center">
              <p className="text-valia-gray-600 text-sm">
                New to Valia?{" "}
                <Link
                  to="/register"
                  className="text-valia-accent hover:text-valia-primary font-medium transition-colors duration-200"
                >
                  Create Account
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
